import { getIn18Text } from 'api';
import React, { useEffect, useState } from 'react';
import Modal from '@web-common/components/UI/Modal/SiriusModal';
import { apiHolder as api, DEFAULT_LANG } from 'api';
import AppIcon from '@/images/favicon.png';
import AppIconEdm from '@/images/favicon_edm.png';
import styles from './languageSwitchModal.module.scss';
const systemApi = api.api.getSystemApi();
const isWebWmEntry = systemApi.isWebWmEntry();
const LanguageSwitchModal = props => {
    const { visible: defulatVisible, onClose: closeModal, content: customContent, lang = DEFAULT_LANG } = props;
    const localLangMap = {
        en: {
            setting_system_switch_info: systemApi.inEdm()
                ? 'To change the language, you need to restart NetEase Foreign Trade to take effect!'
                : 'To change the language, you need to restart NetEase Rhino Office to take effect!',
            setting_system_switch_info_web: 'To change the language, you need to refresh the page to take effect!',
            setting_system_switch: 'Immediate reboot',
            setting_system_switch_web: 'Refresh',
            setting_system_switch_cancel: 'cancel',
        },
        zh: {
            setting_system_switch: getIn18Text('setting_system_switch'),
            setting_system_switch_web: getIn18Text('SHUAXIN'),
            setting_system_switch_cancel: getIn18Text('setting_system_switch_cancel'),
            setting_system_switch_info: systemApi.inEdm() ? getIn18Text('GENGGAIYUYANXUZHONGXIN1010') : getIn18Text('setting_system_switch_info'),
            setting_system_switch_info_web: getIn18Text('setting_system_switch_info_web'),
        },
        'zh-trad': {
            setting_system_switch_info: systemApi.inEdm() ? getIn18Text('GENGGAIYUYANXUZHONGXIN1010') : getIn18Text('GENGGAIYUYANXUZHONGXIN'),
            setting_system_switch_info_web: getIn18Text('GENGGAIYUYANXUYAOSHUA'),
            setting_system_switch: getIn18Text('LIJIZHONGQIv16'),
            setting_system_switch_web: getIn18Text('SHUAXIN'),
            setting_system_switch_cancel: getIn18Text('setting_system_switch_cancel'),
        },
    };
    const getLocalLangLabel = (key) => {
        const currentLangMap = localLangMap[lang] || {};
        return currentLangMap[key] || '';
    };
    const [visible, setVisible] = useState(false);
    const content = customContent
        ? customContent
        : process.env.BUILD_ISELECTRON || process.env.BUILD_ISEDM
            ? getLocalLangLabel('setting_system_switch_info')
            : getLocalLangLabel('setting_system_switch_info_web');
    useEffect(() => {
        setVisible(defulatVisible);
    }, [defulatVisible]);
    return (React.createElement(Modal, { className: styles.switchModal, maskStyle: isWebWmEntry ? { left: 0 } : {}, width: 480, visible: visible, title: null, okText: process.env.BUILD_ISELECTRON || process.env.BUILD_ISEDM ? getLocalLangLabel('setting_system_switch') : getLocalLangLabel('setting_system_switch_web'), cancelText: getLocalLangLabel('setting_system_switch_cancel'), onCancel: () => {
            closeModal(false);
            setVisible(false);
        }, onOk: () => {
            closeModal(true);
            setVisible(false);
        }, centered: true },
        React.createElement("div", { className: styles.modalContent },
            React.createElement("div", null,
                React.createElement("img", { src: process.env.BUILD_ISEDM ? AppIconEdm : AppIcon })),
            React.createElement("div", { className: styles.switchInfo }, content))));
};
export default LanguageSwitchModal;
